<template>
  <div class="home">
    <div class="header"><h1 class="title">ECC - São Pedro São Paulo - Brisamar</h1></div>
    <Menu class="menu">Menu</Menu>
    <div class="main">
      <router-view :key="$route.fullPath"></router-view>
      </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Menu from '@/views/Menu.vue';

export default {
  name: 'home',
  components: {
    Menu,
  },
  created() {
    this.$store.commit('setLoading', false);
  },
};
</script>
<style scoped>
.home {
  display: flex;
  flex-flow: row wrap;
}

.home > * {
  padding: 10px;
  flex: 1 100%;
}

.header {}

.menu {}

.main {
  text-align: left;
}

@media all and (min-width: 600px) {
  .menu {
    flex: 1 0 0;
  }
}

@media all and (min-width: 800px) {
  .main {
    flex: 3 0px;
  }
  .menu {
    order: 1;
  }
  .main {
    order: 2;
  }
}

body {
  padding: 2em;
}
</style>
